export default __webpack_public_path__ + "static/media/14.9deb44fa.png";